module.exports = __webpack_public_path__ + "ce22e92a18f244f8f7183002feb55463.jpg";